import styled from 'styled-components';

export const AmenityList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
